import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CouponHistoryData from "app/Models/Content/CouponHistoryData";
import CouponHistory from './CouponHistory';
export default class CouponHistoryBlock extends EpiComponent<CouponHistoryData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CouponHistory context={this.getContext()} contentData={this.props.data} />;
  }
}
